(function() {

	angular
		.module('ngmvac')
		.filter('zoneFilter', ZoneaFilter);

	function ZoneaFilter() {
		return function(arr, zona) {
			var hotelArray = [];
			var hotelArray2 = [];

			angular.forEach(arr, function(hotel) {
			hotelArray.push(hotel);
			});

         for(var i=0; i<hotelArray.length; i++) 
         {
			if(hotelArray[i].zoneName==zona)
			{
                hotelArray2.push(hotelArray[i]);
			}
		 }

		 if(zona=='Todas')
		 {
		 	return arr;
		 } 
		 else
		 {
          
			return hotelArray2;
		 }

		} 
	}

})();